import ActionsLayout from 'src/features/parkingActions/components/ActionsLayout';

const Customise = () => {
    return <ActionsLayout>Here we can customise :)</ActionsLayout>;
};

export default Customise;
